import { Article } from '../types';

export const toArticleDTO = (article: any): Article => ({
  ...article,
  name: `${article.firstname} ${article.lastname}`,
  isPublished: article.published?.some((value: string) => value !== 'null')
});
